<div class="igntr-theme flex-1 bg-[--background-color]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px] pb-[100px]"
  >
    <app-page-hero
      showSearchBar
      contentColumn
      [title]="'users'"
      [description]="'manageUsers' | transloco"
      [newButton]="{ route: '/users/new', text: 'addUser' }"
      [searchValue]="searchString"
      (searchEmitter)="filterByName($event)"
    >
      <div
        class="igntr-select-for-filter grow basis-full sm:basis-[calc(50%-0.25rem)] xl:grow-0 xl:basis-[200px]"
      >
        <app-datalist-select
          [activeValue]="roleFilterValue"
          [options]="roleFilterOptions"
          [clearable]="true"
          [multiple]="false"
          (activeValueChange)="onRoleFilterChange($event)"
          placeholder="{{ 'anyRole' | transloco }}"
        ></app-datalist-select>
      </div>

      <div
        class="igntr-select-for-filter grow basis-full sm:basis-[calc(50%-0.25rem)] xl:grow-0 xl:basis-[200px]"
      >
        <app-datalist-select
          [activeValue]="groupFilterValue"
          [options]="groupFilterOptions"
          [clearable]="true"
          [multiple]="false"
          (activeValueChange)="onGroupFilterChange($event)"
          placeholder="{{ 'anyGroup' | transloco }}"
        ></app-datalist-select>
      </div>

      <button
        type="button"
        class="inline-flex items-center justify-center gap-1.5 px-3.5 h-9 grow basis-full sm:basis-[calc(50%-0.25rem)] xl:grow-0 xl:basis-auto border rounded-lg text-sm font-medium cursor-pointer transition-colors"
        [ngClass]="
          filtersSaved
            ? '!border-[var(--primary-color)] !text-[var(--primary-color)] !bg-[color-mix(in_srgb,var(--primary-color)_10%,white)]'
            : 'border-gray-200 bg-white text-gray-500 hover:!border-[var(--primary-color)] hover:!text-[var(--primary-color)]'
        "
        (click)="toggleSaveFilters()"
      >
        <igntr-icon
          [name]="filtersSaved ? 'bookmarkCheck' : 'bookmark'"
        ></igntr-icon>
        {{ "saveFilters" | transloco }}
      </button>

      <p-menu #menu [popup]="true" [model]="items"></p-menu>
      <button
        type="button"
        (click)="menu.toggle($event)"
        class="grow basis-full sm:basis-[calc(50%-0.25rem)] xl:grow-0 xl:basis-auto inline-flex items-center justify-center gap-1.5 px-3.5 h-9 rounded-lg bg-[var(--primary-color)] !text-white text-[14px] font-medium shadow-[0_8px_18px_-10px_rgba(15,23,42,.5)] hover:brightness-95 transition"
      >
        {{ "actions" | transloco }}
        <igntr-icon name="chevron"></igntr-icon>
      </button>
    </app-page-hero>

    <div class="mt-4">
      @if (activeTenant && (auth.isTenantAdmin$ | async)) {
        <app-import-export
          [hideButtons]="true"
          filenamePrefix="users"
          [importFactory]="importFactory"
          [exportFactory]="exportFactory"
          (outputError)="showError($event)"
          (submitImport)="submitImport($event)"
          [waitingForImportResponseSet]="waitingForImportResponse$"
        ></app-import-export>
      }

      <app-users-list
        [showFilters]="false"
        style="width: 100%"
        [innerWidth]="innerWidth"
        [users]="users"
        [search]="searchString"
        [clearSelectedUsers]="emptySelectedUsers"
        [isDeleteDisabled]="!(auth.isSuperAdmin$ | async)"
        (delete)="handleDeleteClick($event)"
        (onUserSelection)="handleUserSelection($event)"
      ></app-users-list>

      <p-confirmDialog [style]="{ width: '50vw' }">
        <ng-template pTemplate="footer">
          <button
            pButton
            type="button"
            label="{{ 'yes' | transloco }}"
            class="p-button-secondary"
            (click)="deleteSelectedUsers()"
          ></button>

          <button
            pButton
            type="button"
            label="{{ 'no' | transloco }}"
            (click)="confirmationService.close()"
          ></button>
        </ng-template>
      </p-confirmDialog>
      <p-button
        class="d-block d-sm-none mobile-add-button"
        icon="pi pi-plus"
        routerLink="/users/new"
      />
    </div>
  </div>
</div>
